<template>
  <div class="editBG pt-3 mt-4" style="min-height:100%;margin: 0 auto;">
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      auto-height
      right
      top
      :timeout="timeout"
      vertical
    >
      {{ this.snackbarText }}
    </v-snackbar>

    <!-- <v-toolbar fixed tabs color="white elevation-1" style="top:55px; position:fixed;">
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title>{{contactFormData.name}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon><v-icon>more_vert</v-icon></v-btn>
      <small>{{contact.name}}</small>
      
      <v-tabs slot="extension" color="transparent" slider-color="purple"  align-with-title v-model="currentTabContact">
        <v-tab v-for="tab in ['basic','image']" :ripple="false"
          :key="tab" 
          :href="'#tab-' + tab" 
          @click="saveCurrentTab('tab-' + tab)"
        >
          {{ tab }}
        </v-tab> 
      </v-tabs>
    </v-toolbar> -->

    <v-layout  row wrap style="background-color:white; height:30px; width:100%; top:135px; position:fixed; z-index: 1; height:50px;">
      <v-flex xs12>
      </v-flex>
    </v-layout>

    <v-toolbar
      tabs
      class="elevation-1 editBG mt-2"
      style="top:155px; position:fixed; z-index: 1;"
    >
      <v-toolbar-title class="pl-3 headline" v-html="contactFormData.name">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="c_user.delete_rights" small icon class="mr-3" @click="deleteText()" right>
        <v-icon small color="red">delete</v-icon>
      </v-btn>
      <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
        <v-icon small>close</v-icon>
      </v-btn>
      <v-btn icon small 
        :dark="contactFormData.category != null && contactFormData.name != null && contactFormData.name  != ''"
        :disabled="contactFormData.category == null || (contactFormData.name == null || contactFormData.name == '')"
        @click="submit" right
      > 
        <v-icon small>save</v-icon>
      </v-btn>
    </v-toolbar>

    <v-form @submit.prevent ref="form" v-model="valid" lazy-validation style="min-height:100%;margin: 0 auto;">
      <v-card class="px-3 pt-5 mt-0 elevation-0 editBG" style="height:100%;">
        <v-container grid-list-md fluid style="height:100%;">
          <v-layout row wrap style="height:100%;">
            <v-flex
              style="background-color:#292929; color: #eee;"
              class="px-3 py-0 my-2 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Basic</h3>
            </v-flex>
            <v-flex px-3 xs12>
              <!-- <label>Name</label> -->
              <v-text-field
                label="Name"
                v-model="contactFormData.name"
              ></v-text-field>
            </v-flex>
            <!-- <v-text-field label="Name" v-model="contactFormData.name"></v-text-field> -->
            <v-flex px-3 xs6>
              <v-text-field
                :disabled="contactFormData.category == 'artwork_acquisition_source'"
                label="First Name"
                v-model="contactFormData.first_name"
              ></v-text-field>
            </v-flex>
            <v-flex px-3 xs6>
              <v-text-field
                :disabled="contactFormData.category == 'artwork_acquisition_source'"
                label="Last Name"
                v-model="contactFormData.last_name"
              ></v-text-field>
            </v-flex>
            <v-flex px-3 xs6>
              <v-text-field
                :disabled="contactFormData.category == 'artwork_acquisition_source'"
                label="Company"
                v-model="contactFormData.company"
              ></v-text-field>
            </v-flex>

            <v-select
              class="px-3"
              :items="['artwork_acquisition_source', 'registrar', 'exhibition_institution']"
              v-model="contactFormData.category"
              label="Category * "
            ></v-select>

            <v-flex xs12>
              <v-flex
                mt-3
                ml-2
                class="left"
                v-if="
                  contactFormData.category == null ||
                    contactFormData.name == null
                "
                >* Obligatory fields</v-flex
              >
              <v-spacer></v-spacer>
              <!-- <v-btn
                class="right"
                :dark="contactFormData.category != null && contactFormData.name != null && contactFormData.name  != ''"
                :disabled="contactFormData.category == null || (contactFormData.name == null || contactFormData.name == '')"
                @click="submit"
              > -->
              <!-- 
                :dark="
                  contactFormData.category != null &&
                    contactFormData.name != null
                "
                :disabled="
                  !contactFormData.category && !contactFormData.name != null
                " -->
                <!-- save
              </v-btn>
              <v-btn class="right" @click="$router.go(-1)">cancel</v-btn> -->
            </v-flex>

            <!-- <v-flex xs12>
              <v-btn :disabled="!valid" @click="submit"> save </v-btn>
              <v-btn @click="$router.go(-1)">cancel</v-btn>
            </v-flex> -->
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
// import { mapState } from "vuex";
// import * as qs from "querystring";

export default {
  props: ["contact", "id"],
  data() {
    return {
      contactFormData: Object.assign({}, this.contact),
      snackbar: false,
      snackbarFieldName: "",
      snackbarColor: '',
      snackbarText: '',
      timeout: 3000,
      editContact: false,
      result: "",
      currentTabContact: this.$store.state.currentTabContact,
      valid: true
    };
  },

  // mounted () {
  //   this.$nextTick(() => {
  //     $('.container').hide()
  //     $('.container').fadeIn()
  //   })
  // },
  beforeMount() {
    this.result = this.$route.params.contact;
    // setTimeout(
    //   function() {
      //   }.bind(this),
    //   4000
    // );
    if (!this.result) {
      this.result = this.contact
    }
    this.contactFormData = Object.assign({}, this.result);
    this.getContact();
  },
  methods: {
    humanize(t) {
      return t.replace(/_/g, " ").replace(/(?: |\b)(\w)/g, function(t) {
        return t.toUpperCase();
      });
    },
    verify_accession_no() {
      return false;
    },
    saveCurrentTab(tab) {
      setTimeout(
        function() {
          this.$store.dispatch("saveCurrentTab", tab);
        }.bind(this),
        1000
      );
    },
    getContact() {
      // console.log('test output getcontact')
      let url = `${this.$globals.apiserver}/contacts/${this.contactFormData.id}.json`;
      // let url = `http://www.tba21.org/contact.json?id={{contact.id}}`
      // console.log(url)
      axios
        .get(url)
        .then(response => {
          // this.loading = false;
          this.contactFormData = response.data;
        })
        .catch(error => {
          // console.log(error);
        });
    },
    clear() {
      this.$refs.form.reset();
    },
    submit() {
      // const c = this.contactFormData
      // const requestConfig = {
      //     url     : `${this.$globals.apiserver}/contacts/api_update/${this.$route.params.id}`,
      //     method  : "POST",
      //     data : qs.stringify(c)
      // }
      // const response = axios.request(requestConfig)

      let url = `${this.$globals.apiserver}/contacts/${this.contactFormData.id}.json`;
      // console.log(url)
      axios
        .put(url, { contact: this.contactFormData })
        // {
        //   name: this.contactFormData.name,
        //   category: this.contactFormData.category,
        //   company: this.contactFormData.company,
        //   first_name: this.contactFormData.first_name,
        //   last_name: this.contactFormData.last_name,
        //   id: this.contactFormData.id
        // })
        .then(response => {
          this.snackbar = true
          this.snackbarColor = 'green'
          this.snackbarText = 'Contact was saved.'
          // this.loading = false;
          // console.log(response.data)
          // this.result = response.data
          // this.artwork = response.data
          // this.$store.dispatch('addArtwork',response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
        })
        .catch(error => {
          this.snackbar = true
          this.snackbarColor = 'red'
          this.snackbarText = 'Error Occured while saving Contact'
          // console.log(error);
        });
    }
  }
  // computed: {
  //   contact2() {
  //     let contact = this.result;
  //     // console.log(contact)
  //     // this.contact.map(contact => {
  //     //   let a = contact
  //     //   contact.first_name = a ? a.first_name : 'nema meno'
  //     // })
  //     // console.log(this.contact)
  //     return contact;
  //   }
  // }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contacts/EditContact.vue